module.exports = __webpack_public_path__ + "static/media/rsz_massan-123.ae9ff65a.jpg";